import '@starfederation/datastar/bundles/datastar';

import {
  addBasicEditor,
  PrismEditorElement,
} from 'prism-code-editor/web-component';

import './cedar-grammar.js';

import './styles.css';

import 'https://early.webawesome.com/webawesome@3.0.0-alpha.13/dist/components/avatar/avatar.js';
import 'https://early.webawesome.com/webawesome@3.0.0-alpha.13/dist/components/badge/badge.js';
import 'https://early.webawesome.com/webawesome@3.0.0-alpha.13/dist/components/button/button.js';
import 'https://early.webawesome.com/webawesome@3.0.0-alpha.13/dist/components/button-group/button-group.js';
import 'https://early.webawesome.com/webawesome@3.0.0-alpha.13/dist/components/breadcrumb/breadcrumb.js';
import 'https://early.webawesome.com/webawesome@3.0.0-alpha.13/dist/components/breadcrumb-item/breadcrumb-item.js';
import 'https://early.webawesome.com/webawesome@3.0.0-alpha.13/dist/components/callout/callout.js';
import 'https://early.webawesome.com/webawesome@3.0.0-alpha.13/dist/components/card/card.js';
import 'https://early.webawesome.com/webawesome@3.0.0-alpha.13/dist/components/checkbox/checkbox.js';
import 'https://early.webawesome.com/webawesome@3.0.0-alpha.13/dist/components/copy-button/copy-button.js';
import 'https://early.webawesome.com/webawesome@3.0.0-alpha.13/dist/components/dialog/dialog.js';
import 'https://early.webawesome.com/webawesome@3.0.0-alpha.13/dist/components/divider/divider.js';
import 'https://early.webawesome.com/webawesome@3.0.0-alpha.13/dist/components/dropdown/dropdown.js';
import 'https://early.webawesome.com/webawesome@3.0.0-alpha.13/dist/components/icon/icon.js';
import 'https://early.webawesome.com/webawesome@3.0.0-alpha.13/dist/components/icon-button/icon-button.js';
import 'https://early.webawesome.com/webawesome@3.0.0-alpha.13/dist/components/input/input.js';
import 'https://early.webawesome.com/webawesome@3.0.0-alpha.13/dist/components/option/option.js';
import 'https://early.webawesome.com/webawesome@3.0.0-alpha.13/dist/components/menu/menu.js';
import 'https://early.webawesome.com/webawesome@3.0.0-alpha.13/dist/components/page/page.js';
import 'https://early.webawesome.com/webawesome@3.0.0-alpha.13/dist/components/scroller/scroller.js';
import 'https://early.webawesome.com/webawesome@3.0.0-alpha.13/dist/components/select/select.js';
import 'https://early.webawesome.com/webawesome@3.0.0-alpha.13/dist/components/skeleton/skeleton.js';
import 'https://early.webawesome.com/webawesome@3.0.0-alpha.13/dist/components/switch/switch.js';
import 'https://early.webawesome.com/webawesome@3.0.0-alpha.13/dist/components/tab/tab.js';
import 'https://early.webawesome.com/webawesome@3.0.0-alpha.13/dist/components/tab-group/tab-group.js';
import 'https://early.webawesome.com/webawesome@3.0.0-alpha.13/dist/components/tab-panel/tab-panel.js';
import 'https://early.webawesome.com/webawesome@3.0.0-alpha.13/dist/components/textarea/textarea.js';
import 'https://early.webawesome.com/webawesome@3.0.0-alpha.13/dist/components/tooltip/tooltip.js';

import { registerIconLibrary } from 'https://early.webawesome.com/webawesome@3.0.0-alpha.13/dist/webawesome.js';

registerIconLibrary('default', {
  resolver: (name: string) => `/icons/${name}.svg`,
});

addBasicEditor('prism-editor');
const editorElement =
  document.querySelector<PrismEditorElement>('prism-editor');

declare global {
  interface Window {
    fixDOM: () => void;
    filterQuery: (newFilter: string) => string;
  }
}

const mobileToggle = document.getElementById('mobile-toggle');
const sidebar = document.getElementById('sidebar');
const overlay = document.getElementById('overlay');

mobileToggle?.addEventListener('click', function () {
  sidebar?.classList.toggle('open');
  overlay?.classList.toggle('open');
});

// Close sidebar when clicking outside on mobile
document.addEventListener('click', function (event) {
  const isSmallScreen = window.innerWidth <= 768;
  const isOutsideClick =
    !sidebar?.contains(event.target as Node) &&
    !mobileToggle?.contains(event.target as Node);
  const isSidebarOpen = sidebar?.classList.contains('open');

  if (isSmallScreen && isOutsideClick && isSidebarOpen) {
    sidebar?.classList.remove('open');
    overlay?.classList.remove('open');
  }
});

function setNavLinkActive() {
  // First fetch the base URL from the base tag
  const baseTag = document.querySelector('base');
  const baseUrl = baseTag?.getAttribute('href') ?? '';
  const currentPath = window.location.pathname
    .replace(baseUrl, '')
    .split('/')[0];
  const navLink = document.querySelector(
    'a.nav-link[href="' + currentPath + '"]'
  );
  if (navLink) {
    // Remove active class from all nav links
    const allNavLinks = document.querySelectorAll('a.nav-link');
    allNavLinks.forEach((link) => {
      link.classList.remove('active');
    });

    navLink.classList.add('active');
  }
}

// For all tds with no-data, count the th in the first thead > tr in the
// parent table and set the colspan to the number of ths
function setNoDataColspan() {
  const noDataTds = document.querySelectorAll('td[no-data]');
  noDataTds.forEach((td) => {
    const table = td.closest('table');
    const ths = Array.from(table?.querySelector('thead > tr')?.children ?? []);
    td.setAttribute('colspan', ths.length.toString());
  });
}

// For any element that has always-show attribute, check all children recursively
// and change any data-show="!$datafetching" to data-show="true"
function setAlwaysShow() {
  const elements = document.querySelectorAll('[always-show]');
  elements.forEach((element) => {
    const children = element.querySelectorAll('*');
    children.forEach((child) => {
      if (child.getAttribute('data-show') === '!$datafetching') {
        child.setAttribute('data-show', 'true');
      }
    });
  });
}

var eventListeners = new Map<Element, any>();
function addEventListener(
  element: Element,
  event: string,
  listener: EventListener
) {
  if (eventListeners.has(element)) {
    eventListeners.get(element)?.push(listener);
  } else {
    eventListeners.set(element, [listener]);
  }
  element.addEventListener(event, listener);
}
function cleanupEventListeners() {
  eventListeners.forEach((listeners, element) => {
    listeners.forEach((listener) => {
      element.removeEventListener(listener.event, listener.listener);
    });
  });
}

function fixDOM() {
  cleanupEventListeners();
  setNavLinkActive();
  setNoDataColspan();
  setAlwaysShow();

  // Remove all hidden elements with is-sse attribute
  const hiddenElements = document.querySelectorAll('div[is-sse]');
  hiddenElements.forEach((element) => {
    element.remove();
  });

  // All a/links in header without href should not act like a link (as in do not go to base)
  const headerLinks = document.querySelectorAll('header > a');
  headerLinks.forEach((link) => {
    if (!link.hasAttribute('href')) {
      link.setAttribute('no-sse', '');
      addEventListener(link, 'click', function (event: any) {
        event.preventDefault();
        event.stopPropagation();
      });
    }
  });

  // First fetch the base URL from the base tag
  const baseTag = document.querySelector('base');
  const baseUrl = baseTag ? baseTag.getAttribute('href') : '';

  // Select all links that need to be converted to SSE calls, all links except
  // for links with no-sse attribute
  const links = document.querySelectorAll('a:not([no-sse])');

  links.forEach((link) => {
    // If the parent is a wa-tab, then don't add the SSE attribute
    if (link.parentElement?.tagName === 'WA-TAB') {
      return;
    }

    // Extract the original href
    const href = baseUrl + (link.getAttribute('href') || '');

    // Keep the original href (for middle-click, etc.)
    // Add the datastar attribute to handle SSE to a hidden element.
    // This is needed because there is no programmatic way to call Datastar.
    const hiddenElement = document.createElement('div');
    hiddenElement.style.display = 'none';
    document.body.appendChild(hiddenElement);

    hiddenElement.setAttribute(
      'data-on-click',
      `@get('${href}', {
      headers: {
        'X-Pluriscale-SSE-Link': 'true',
        'X-Pluriscale-SSE-Target': '${href}',
      }
    })`
    );
    hiddenElement.setAttribute('data-indicator', 'pageFetching');
    hiddenElement.setAttribute('is-sse', 'true');

    // Add click event listener to prevent default navigation
    addEventListener(link, 'click', function (event: any) {
      // If ctrl/cmd clicked then open in new tab
      if (event.ctrlKey || event.metaKey) {
        return;
      }

      // If middle-click, open in new tab
      if (event.button === 1) {
        return;
      }

      event.preventDefault();
      hiddenElement.click();
    });
  });

  // For every wa-tab click, capture it, prevent default and SSE (if any)
  const tabs = document.querySelectorAll('wa-tab');
  tabs.forEach((tab) => {
    const href = tab.getAttribute('href');
    if (!href) {
      return;
    }

    // If disabled, don't add the SSE attribute
    if (tab.hasAttribute('disabled')) {
      return;
    }

    // For the first element in the tab (not the shadow root) we need
    // to add an a element with the href attribute.
    // This is so people can right click and open in new tab.
    const a = document.createElement('a');
    a.href = tab.getAttribute('href') || '';
    a.setAttribute('no-sse', 'true');

    // Get the first child and replace it with the a element
    const firstChild = tab.firstChild;
    if (firstChild) {
      a.innerHTML = firstChild.textContent || '';
      tab.replaceChild(a, firstChild);
    }

    // Keep the original href (for middle-click, etc.)
    // Add the datastar attribute to handle SSE to a hidden element.
    // This is needed because there is no programmatic way to call Datastar.
    const hiddenElement = document.createElement('div');
    hiddenElement.style.display = 'none';
    document.body.appendChild(hiddenElement);

    hiddenElement.setAttribute(
      'data-on-click',
      `@get('${baseUrl}${href}', {
      headers: {
        'X-Pluriscale-SSE-Link': 'true',
        'X-Pluriscale-SSE-Target': '${baseUrl}${href}',
      }
    })`
    );
    hiddenElement.setAttribute('data-indicator', 'tabFetching');
    hiddenElement.setAttribute('is-sse', 'true');

    addEventListener(a, 'click', function (event: any) {
      event.preventDefault();
    });

    addEventListener(tab, 'click', function (event: any) {
      event.preventDefault();
      event.stopPropagation();

      // If ctrl/cmd clicked then open in new tab
      if (event.ctrlKey || event.metaKey) {
        window.open(baseUrl + href, '_blank');
        return;
      }

      // If middle-click, open in new tab
      if (event.button === 1) {
        window.open(baseUrl + href, '_blank');
        return;
      }

      hiddenElement.click();
    });
  });

  // For wa-buttons with open-dialog attribute, automatically add a
  // click handler to open the target dialog
  const buttons = document.querySelectorAll('wa-button[open-dialog]');
  buttons.forEach((button) => {
    const targetId = button.getAttribute('open-dialog');
    if (!targetId) {
      return;
    }

    const target = document.getElementById(
      targetId
    ) as HTMLDialogElement | null;
    if (!target) {
      return;
    }

    addEventListener(target, 'wa-hide', function (event: any) {
      if (event.detail.source.classList.contains('show')) {
        event.preventDefault();
      }
    });

    addEventListener(button, 'click', function (event) {
      target.open = true;
    });
  });

  // Every time wa-switch emits the change event, update the value of the
  // switch with the value of the checked attribute.
  // It also sets the initial checked state of the switch with the value.
  const switches = document.querySelectorAll('wa-switch');
  switches.forEach((s) => {
    const switchElement = s as HTMLInputElement;
    switchElement.checked = switchElement.value === 'true';

    addEventListener(s, 'change', function (event) {
      const switchElement = event.currentTarget as HTMLInputElement;
      switchElement.value = switchElement.checked.toString();
    });
  });

  // Same with wa-checkboxes
  const checkboxes = document.querySelectorAll('wa-checkbox[bool-value]');
  checkboxes.forEach((c) => {
    const checkboxElement = c as HTMLInputElement;
    checkboxElement.checked = checkboxElement.value === 'true';

    addEventListener(c, 'change', function (event) {
      const checkboxElement = event.currentTarget as HTMLInputElement;
      checkboxElement.value = checkboxElement.checked.toString();
    });
  });
}

const fixDom = document.getElementById('fix_dom') as HTMLElement;
const observer = new MutationObserver(fixDOM);
observer.observe(fixDom, { childList: true, subtree: true });

window.addEventListener('popstate', function (e) {
  window.location.reload();
});

document.addEventListener('DOMContentLoaded', fixDOM);

function filterQuery(newFilter: string): string {
  const query = new URLSearchParams(window.location.search);
  query.set('filter', newFilter);
  return query.toString();
}
window.filterQuery = filterQuery;
